import React from 'react';
import { MantineProvider, createTheme } from '@mantine/core';
import '@mantine/core/styles.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NewsletterRegistration from './components/Newsletter/NewsletterRegistration';
import OptOutPage from './components/Newsletter/OptOutPage';
import DoiConfirmationPage from './components/Newsletter/DoiConfirmationPage';
import './styles/global.css';
import DatenschutzPage from './components/Legal/DatenschutzPage';

const theme = createTheme({
  primaryColor: 'blue',
  fontFamily: 'Inter, sans-serif',
  components: {
    Button: {
      defaultProps: {
        size: 'md',
        radius: 'md'
      }
    },
    TextInput: {
      defaultProps: {
        size: 'md',
        radius: 'md'
      }
    },
    Select: {
      defaultProps: {
        size: 'md',
        radius: 'md'
      }
    },
    MultiSelect: {
      defaultProps: {
        size: 'md',
        radius: 'md'
      }
    },
    Textarea: {
      defaultProps: {
        size: 'md',
        radius: 'md'
      }
    }
  }
});

const App: React.FC = () => {
  return (
    <MantineProvider theme={theme}>
      <Router>
        <Routes>
          <Route path="/" element={<NewsletterRegistration />} />
          <Route path="/datenschutz" element={<DatenschutzPage />} />
          <Route path="/opt-out" element={<OptOutPage />} />
          <Route path="/newsletter-bestaetigung" element={<DoiConfirmationPage />} />
        </Routes>
      </Router>
    </MantineProvider>
  );
};

export default App;
